import React from "react";
import { WhatsappLogo } from "@phosphor-icons/react";

export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/19732883496"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg shadow-[#25D366]/30 hover:scale-110 transition-transform duration-300"
      data-testid="whatsapp-float"
      aria-label="WhatsApp"
    >
      <WhatsappLogo size={28} weight="fill" className="text-white" />
    </a>
  );
}
